import { render } from "./Navigation.vue?vue&type=template&id=48907c89&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=48907c89&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48907c89"]])

export default __exports__